import { RotatingLines } from "react-loader-spinner";
import { useState, useEffect, useRef } from "react";
import Constants from "../../../Constants";
import SuccessMessage from "../../../components/SuccessMessage";
import jQuery from "jquery";

export default function ExactTargetCredential (props) {

  const clientIdRef = useRef(null);
  const clientSecretRef = useRef(null);
  const subDomainRef = useRef(null);

  const credentialData = props.credentialData;
  const [errorMessages, setErrorMessages] = useState(props.errorMessages);
  const [successMessage, setSuccessMessage] = useState(props.successMessage);
  const [clientId, setClientId] = useState(clientIdRef.current?.value);
  const [clientSecret, setClientSecret] = useState(clientSecretRef.current?.value);
  const [subDomain, setSubDomain] = useState(subDomainRef.current?.value);

  useEffect(() => {
    if (props.errorMessages?.length > 0) {
      setErrorMessages(props.errorMessages)
    }
  }, [props.errorMessages])

  useEffect(()=>{
    if(props.successMessage!==Constants.BLANK){
      setSuccessMessage(props.successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
      },5000);
    }
  },[props.successMessage]);

  useEffect(() => {
    const saveCredentialButton = jQuery("#save-credential");
    const validateCredButton = jQuery("#validate-credential");
    if (clientId?.length > 0 && clientSecret?.length > 0 && subDomain?.length > 0) {
      saveCredentialButton?.removeAttr("disabled");
      validateCredButton?.removeAttr("disabled");
    } else {
      saveCredentialButton?.attr("disabled",  "true")
      validateCredButton?.attr("disabled", "true")
    }
  }, [clientId, clientSecret, subDomain]);

  const onChnageInputFields = () => {
    setClientId(clientIdRef.current?.value);
    setClientSecret(clientSecretRef.current?.value)
    setSubDomain(subDomainRef.current?.value)
  }

  return (
    <>
    <div className={props.isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
    </div> 
    {errorMessages?.length > 0 &&
      <><ul id="brightcoveServerError" className="list-error">
      {errorMessages?.map(error => {
        return (<li>{JSON.stringify(error)}</li>) 
      })}
      </ul><br/></>
    }
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}

     <div className="global-dropdown-block mr-0">
      <label>Your ExactTarget client ID</label>
        <div className="global-dropdown-select">
          <input id="exacttarget-client-id-input" type="text" className="form-control-sm" placeholder="ExactTarget client ID" defaultValue={credentialData?.credentials?.CLIENT_ID} 
          ref={clientIdRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
      <label>Your ExactTarget client secret</label>
        <div className="global-dropdown-select">
          <input id="exacttarget-client-secret-input" type="text" className="form-control-sm" placeholder="ExactTarget client secret" defaultValue={credentialData?.credentials?.CLIENT_SECRET} 
          ref={clientSecretRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
      <label>Sub Domain</label>
        <div className="global-dropdown-select">
          <input id="exacttarget-sub-domain-input" type="text" className="form-control-sm" placeholder="Sub Domain" defaultValue={credentialData?.credentials?.SUB_DOMAIN} 
          ref={subDomainRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
    </>
  )
}


